module.exports = __webpack_public_path__ + "img/STERiGLIDE_02_01.cb044b5c.jpg";